
import { mmToPx, pxToMm } from "@/utils/screen";
import Vue from "vue";
import { LayoutEditorEventBus } from "./layout-editor-event-bus";

export default Vue.extend({
	data() {
		return {
			scaling: false,
			offsetX: 0,
			offsetY: 0,
			dragWidth: 0,
			dragHeight: 0,
		};
	},

	props: {
		width: Number,
		height: Number,
		minWidth: Number,
		minHeight: Number,
		maxHeight: Number,
		maxWidth: Number
	},

	computed: {
		widthPx():number {
			return mmToPx(this.width);
		},
		heightPx():number {
			return mmToPx(this.height);
		}
	},

	watch: {
		width(width: number) {
			console.log(this.minWidth, this.maxWidth);
			if (this.maxWidth <= this.minWidth) return;
			if (this.minWidth != null) {
				if (width <= this.minWidth) {
					this.dragWidth = this.minWidth;
					this.$emit("update:width", this.minWidth);
					return;
				}
			}
			if (this.maxWidth != null) {
				if (width > this.maxWidth) {
					this.dragWidth = this.maxWidth;
					this.$emit("udpate:width", this.maxWidth);
				}
			}
		},
		height(height: number) {
			if (this.maxHeight <= this.minHeight) return;
			if (this.minHeight != null) {
				if (height <= this.minHeight) {
					//this.offsetY = 0;
					this.dragHeight = this.minHeight;
					this.$emit("update:height", this.minHeight);
					return;
				}
			}
			if (this.maxHeight != null) {
				if (height > this.maxHeight) {
					this.dragHeight = this.maxHeight;
					this.$emit("udpate:height", this.maxHeight);
				}
			}
		},
		minWidth(){
			this.validate();
		},
		maxWidth(){
			this.validate();
		},
		minHeight(){
			this.validate();
		},
		maxHeight(){
			this.validate();
		}
	},

	methods: {
		onMouseDown(event: MouseEvent) {
			this.scaling = true;
			this.offsetX = LayoutEditorEventBus.mouseX;
			this.offsetY = LayoutEditorEventBus.mouseY;
			this.dragWidth = this.widthPx;
			this.dragHeight = this.heightPx;
			LayoutEditorEventBus.dragging = true;
			this.$emit("mouse-down");
		},
		onMouseMove(data:{x:number, y:number}){
			if (!this.scaling) return;
			let width = pxToMm(this.dragWidth + data.x - this.offsetX);
			let height = pxToMm(this.dragHeight + data.y - this.offsetY);
			if (width < this.minWidth) {
				width = this.minWidth;
			}
			if (height < this.minHeight) {
				height = this.minHeight;
			}
			if (width > this.maxWidth) {
				width = this.maxWidth;
			}
			if (height > this.maxHeight){
				height = this.maxHeight;
			}
			this.$emit("update:width", width);
			this.$emit("update:height", height);
		},
		onMouseUp(){
			this.scaling = false;
			LayoutEditorEventBus.dragging = false;
		},
		validate(){
			if (this.width > this.maxWidth) {
				this.$emit("update:width", this.maxWidth);
			}
			if (this.height > this.maxHeight) {
				this.$emit("update:height", this.maxHeight);
			}
		}
	},
	created() {
		LayoutEditorEventBus.$on("mouse-move", this.onMouseMove);
		LayoutEditorEventBus.$on("mouse-up",this.onMouseUp);
	},
	mounted(){
		this.validate();
	},
	destroyed(){
		LayoutEditorEventBus.$off("mouse-move", this.onMouseMove);
		LayoutEditorEventBus.$off("mouse-up",this.onMouseUp);
	}
});
